import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateRequestStatusHistoryElementDtoGen,
  MrfiktivRepairEstimateViewModelGen,
  MrfiktivUpdateRepairEstimateResponseAcceptDtoGen
} from "../v1/data-contracts";
import { RepairEstimateRequest } from "../v1/RepairEstimateRequest";

/**
 * Communicate with RepairEstimateRequest API
 */
class RepairEstimateRequestService {
  mrfiktivProxy: RepairEstimateRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new RepairEstimateRequest(mrfiktivHttpClientProvider.client());
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param repairEstimateId
   * @param token
   * @returns
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    repairEstimateId: string,
    token: string
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const shared = await this.mrfiktivProxy.repairEstimateRequestControllerGet({
      partnerId,
      repairEstimateId,
      sct: token
    });

    return shared.data;
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param repairEstimateId
   * @param token
   * @param data
   * @returns
   */
  async respondAccept(
    partnerId: string,
    repairEstimateId: string,
    token: string,
    data: MrfiktivUpdateRepairEstimateResponseAcceptDtoGen
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const shared = await this.mrfiktivProxy.repairEstimateRequestControllerAccept(
      { partnerId, repairEstimateId, sct: token },
      data
    );

    return shared.data;
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param repairEstimateId
   * @param token
   * @param data
   * @returns
   */
  async respondReject(
    partnerId: string,
    repairEstimateId: string,
    token: string,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen
  ): Promise<MrfiktivRepairEstimateViewModelGen> {
    const shared = await this.mrfiktivProxy.repairEstimateRequestControllerReject(
      { partnerId, repairEstimateId, sct: token },
      data
    );

    return shared.data;
  }
}

/**
 * Communicate with RepairEstimateRequest API
 */
export default new RepairEstimateRequestService(new MrfiktivHttpClientProvider());
